module.exports = __webpack_public_path__ + "img/skin-redness-result-en.49da9363.jpg";